<template lang="pug">
  
  transition(
    @enter="enter" 
    @leave="leave" 
    :css="false" 
  )
    
    section(v-if="show")#home-cta.section 
      
      .inner( ref="content" )

        .copy
          p( 
            v-html="copy" 
            tabindex="-1"
          ).headline

          .buttons-wrap 
            outline-btn( 
              ref="ctaButton" 
              :target="'_blank'" 
              :url="lang_en['site-check-rating-url']" 
              :showArrow="false"  
              :copy="lang_en['site-check-rating-btn']" 
              ).check-your-rating 

        video-component( 
          ref="videoComponent" 
          :poster="poster" 
          :src="youtubeId" 
          :show="show" 
          ).video-component

      share-component(ref="share").share-component

</template>

<script>

import gsap from 'gsap' 
import { mapState, mapMutations, mapGetters } from 'vuex' 
import { PATHS, HOME } from 'src/config/app'  
import { map } from '@/helpers/MathUtils'
import BaseSectionMixin from '@/components/home/sections/mixins/BaseSection' 
import OutlineBtn from '@/components/common/OutlineBtn'
import VideoComponent from '@/components/common/VideoComponent'
import ShareComponent from '@/components/share' 
 
export default {
 
  components: {
    OutlineBtn,
    VideoComponent,
    ShareComponent
  },

  props: {},
  
  mixins: [BaseSectionMixin],

  data() {
    return { 
    }
  },

  computed: {

    ...mapGetters('app', ['getSectionById']),
    ...mapState('app', [ 'motion_clamp' ]) ,
    
    section(){ 
      return this.getSectionById(HOME.SECTIONS.CTA)
    },

    copy(){
      return this.lang_en['home-footer-copy']
    },

    poster(){ 
      return require('@/assets/imgs/youtube-thumb.jpg')
    },

    youtubeId(){
      return 'jrIExEu0LRg'
    }

  },

  mounted() { },

  beforeDestroy() {},

  methods: {
    
    enter(el, done){

      gsap.killTweensOf([this.$refs.content ])

      done()
  
      gsap.fromTo(this.$refs.content, {
        z: -500,
        x: 100,
        y: -100,
        rotationY: 10,
        rotationX: 10,
        opacity: 0,
      }, {
        duration: (this.base_duration * this.motion_clamp),
        z: 0,
        x: 0,
        y: 0,
        rotationY: 0,
        rotationX: 0,
        opacity: 1,
        delay: (this.base_duration * 0.62 * this.motion_clamp),
        ease: 'expo.out' 
      }) 

      this.$refs.share.enter(2, this.base_duration)
      this.$refs.ctaButton.enter()
    },

    leave(el, done){

      gsap.killTweensOf([this.$refs.content ])

      this.$refs.videoComponent.leave()
      this.$refs.ctaButton.leave()
      this.$refs.share.leave()
      
      gsap.to(this.$refs.content, {
        duration: (this.base_duration * 0.4 * this.motion_clamp),
        z: -100,
        x: 300,
        y: -100,
        rotationY: 20,
        rotationX: 10,
        opacity: 0,
        ease: 'power3.in',
        onComplete: done
      })
 
    }

  },

  watch: {},

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#home-cta    
  padding: 0 $bp-desktop-margin
  align-items: center
  justify-content: center
 
  @media all and (max-width: $bp-mobile) 
    padding: 0 $bp-mobile-margin

  .share-component 
    bottom: 3rem
    left: 5rem
    position: absolute
    opacity: 0

    @media all and (max-width: $bp-mobile)
      width: calc(100% - (3.7rem * 2))
      left: auto
 
  .inner
    position: relative
    width: 100%  
    display: flex
    justify-content: space-between
    max-width: 108rem

    @media all and (max-width: $bp-mobile) 
      flex-direction: column
      text-align: center
      margin-bottom: -5rem

    .video-component 
      @media all and (max-width: $bp-mobile) 
        order: 0

    .copy
      position: relative    
      width: 45rem
      display: flex
      flex-direction: column
      justify-content: center

      @media all and (max-width: $bp-mobile) 
        order: 1
        width: 100%
        padding: 4rem 0 5rem

    

    .headline
      opacity: 1

      @media all and (max-width: $bp-mobile) 
        margin-bottom: 1rem
      

    .buttons-wrap
      margin-top: 2rem
      position: relative
 


</style>
